module.exports = __webpack_public_path__ + "static/media/gift.1fd89abe.jpeg";